import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"
import { Link } from "react-router-dom"
import logoLightPng from "../../assets/images/logo-light.png"

const Sidebar = props => {

  return (
    <React.Fragment>
      <div className={`vertical-menu ${props.isParent ? "parent-sidebar" : ""}`}>
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoLightPng} alt="TALC" height="20" />
            </span>
            <span className="logo-lg">
              <img src={logoLightPng} alt="TALC" height="60" />
            </span>
          </Link>
          {props.showParentToggle && (
            <button
              type="button"
              className="parent-sidebar-toggle"
              onClick={props.onToggle}
              aria-label="Collapse navigation"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
          )}
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
  isParent: PropTypes.bool,
  showParentToggle: PropTypes.bool,
  onToggle: PropTypes.func,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
